"use strict";
/**
 * Do not edit directly
 * Generated on Fri, 17 Mar 2023 04:59:02 GMT
 */
exports.__esModule = true;
exports.StrokeXl = exports.StrokeL = exports.StrokeM = exports.StrokeS = void 0;
exports.StrokeS = "1px";
exports.StrokeM = "2px";
exports.StrokeL = "3px";
exports.StrokeXl = "4px";
